module.exports = __webpack_public_path__ + "media/elevadizo/buqueCargadorDerecha-dd-ap-aee1eb95.png";